module.exports = __webpack_public_path__ + "images/restrnt.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/restrnt.png
// module id = 128
// module chunks = 0